import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "../assets/css/next.css";
import Papa from "papaparse";

var Loader = require("react-loader");

const Lists = () => {
    const [loaded, setLoaded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [images, setImages] = useState([]);

    useEffect(() => {
        const sheetURL =
            "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJB4XDn4cM60lvPxxVwBp8--5AHiSti_X9DNNSbnH_L1SnzodWZRsBM2E8wFUKbdIzsdBQMga5x-Dr/pub?output=csv";

        Papa.parse(sheetURL, {
            download: true,
            header: true,
            complete: function (results) {
                const rows = results.data;

                // Clean empty rows
                const cleanRows = rows.filter((row) => row.travel);

                // Convert to usable list
                const parsedImages = cleanRows.map((row) => ({
                    src: row.travel,
                }));

                setImages(parsedImages);
                setLoaded(true);
            },
        });
    }, []);

    const showImage = (index) => {
        setSelectedImageIndex(index);
        setIsModalOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setIsModalOpen(false);
        document.body.style.overflow = "auto";
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div className="our-upcoming-section text-center">
            <div className="container">

                {/* Heading */}
                <div className="row" style={{ paddingTop:"100px" }}>
                    <div className="tour-dreams">
                        <h1 className="normal-text1">
                            Upcoming <span className="colGreen1">
                                Trips
                                <p className="LineSVG1">
                                    <img src="images/line-vector.png" alt="line" />
                                </p>
                            </span>
                        </h1>
                    </div>
                </div>

                {/* GALLERY GRID */}
                <Loader loaded={loaded}>
                    <div className="row mx-md-2 our-trip-images">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="col-lg-4 col-md-4 col-sm-6 img-container1 p-0 px-md-2 m-0"
                                onClick={() => showImage(index)}
                            >
                                <img
                                    src={image.src}
                                    alt="Gallery"
                                    className="upcome-img col-lg-11 mb-4"
                                />
                            </div>
                        ))}
                    </div>

                    {/* MODAL */}
                    <div className="modal gallery-mobile" style={{ display: isModalOpen ? "flex" : "none", backgroundColor: "transparent", backdropFilter: "blur(5px)", width: "100%", margin: "auto", zIndex: "99999"}}>

                        <div className="trip-container" style={{ position: 'relative', alignItems: 'center', justifyContent: 'center' }}>
                            
                            <button 
                                onClick={handlePrev} 
                                style={{
                                    position: 'absolute',
                                    left: '20px',
                                    zIndex: 1000,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>

                            {/* MAIN SELECTED IMAGE */}
                            <div className="selectedimgtrip">
                                {images[selectedImageIndex] && (
                                    <LazyLoadImage src={images[selectedImageIndex].src} alt="Selected" />
                                )}
                            </div>

                            <button 
                                onClick={handleNext} 
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    zIndex: 1000,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>

                            <span className="close-trip" onClick={closeModal}>X</span>

                        </div>
                    </div>
                </Loader>
            </div>
        </div>
    );
};

export default Lists;
